<template>
  <div style="margin: 12px auto; width: 94%">
    <div style="float: left; width: calc(100% - 130px); padding: 5px 0">
      <div
        style="
          color: #fff;
          font-size: 16px;
          position: relative;
          height: 32px;
          line-height: 32px;
        "
      >
        <div
          style="
            float: left;
            max-width: calc(100% - 30px);
            overflow: hidden;
            white-space: nowrap;
          "
        >
          {{ safeItem.title }}
        </div>
        <div style="">
          &nbsp;
          <van-icon name="question-o" @click="togglePopover()" />
        </div>
      </div>
      <van-progress
        :percentage="safeItem.progress"
        pivot-color="#cca352"
        color="#cca352"
        stroke-width="8"
        style="margin-top: 10px"
      />
    </div>
    <div style="float: right; width: 125px; text-align: center">
      <div
        v-if="!safeItem.is_completed"
        style="
          border: 2px solid #cca352;
          padding: 5px 10px;
          color: #fff;
          border-radius: 15px;
          color: #cca352;
        "
        @click="toPage"
      >
        去完成
      </div>
      <div
        v-else-if="safeItem.is_completed && !safeItem.is_claimed"
        style="
          border: 2px solid #cca352;
          padding: 5px 10px;
          color: #fff;
          border-radius: 15px;
          color: #cca352;
        "
        @click="GetUsrTasklist(safeItem)"
      >
        领取
      </div>
      <div
        v-else
        style="
          border: 2px solid rgb(106, 106, 115);
          padding: 5px 10px;
          color: #fff;
          border-radius: 15px;
          color: rgb(106, 106, 115);
        "
      >
        已领取
      </div>
      <van-row style="margin-top: 8px; color: #cca352">
        <van-col :span="12" style="font-size: 16px"
          ><van-icon name="gold-coin-o" />&nbsp;{{
            safeItem.reward_bonus
          }}</van-col
        >
        <van-col :span="12" style="font-size: 16px; text-align: right"
          ><van-icon name="like-o" />&nbsp;{{ safeItem.reward_points }}</van-col
        >
      </van-row>
    </div>
    <div style="clear: both"></div>
    <van-divider />
   
  </div>
</template>

<script>
export default {
  name: 'TaskItemView',
  props: ['item'],
  computed: {
    safeItem () {
      return this.item || {}
    }
  },
  methods: {
    togglePopover () {
      if (this.safeItem.content && this.safeItem.content.length > 0) {
      
        this.$emit('show-item',this.safeItem)
      }
    },
    toPage () {
      this.$router.push({ name: 'home' });
    },
    async GetUsrTasklist(){
      await this.$http({
        method: 'get',
        url: 'claimTask',
        data: { task_id: this.safeItem.id }
      }).then(res => {
        this.$toast.success(res.msg)
        this.$emit('refresh')
      })
    },
  }
}
</script>

<style></style>
